module.exports = __webpack_public_path__ + "img/city-front.ff8b0013.svg";